import Cookies from 'js-cookie';

import {
  AUDIOBOOK_ID_COOKIE_NAME,
  AUTH_TOKEN_COOKIE_NAME,
  CHALLENGE_ID_COOKIE_NAME,
  COOKIE_DOMAIN,
  LOGIN_TOKEN_SUCCEED_COOKIE_NAME,
  USER_ROLE_COOKIE_NAME,
} from 'src/utils/env';
import { BeekUserRole } from 'src/utils/user';
import {
  CHALLENGE_ID_COOKIE_MAX_AGE_DAYS,
  TOKEN_COOKIE_MAX_AGE_DAYS,
} from 'src/config/Const';

// The auth token is a token string used to authenticate the user.
// It is stored in a cookie and is used across different applications.
export const authToken = (): string | undefined => {
  const token = Cookies.get(AUTH_TOKEN_COOKIE_NAME);
  return token ?? undefined;
};

export const setAuthToken = (token: string): void => {
  Cookies.set(AUTH_TOKEN_COOKIE_NAME, token, {
    domain: COOKIE_DOMAIN,
    expires: TOKEN_COOKIE_MAX_AGE_DAYS,
  });
};

export const deleteAuthToken = (): void => {
  Cookies.remove(AUTH_TOKEN_COOKIE_NAME, { domain: COOKIE_DOMAIN });
};

export const deleteLoginTokenSucceed = (): void => {
  Cookies.remove(LOGIN_TOKEN_SUCCEED_COOKIE_NAME, { domain: COOKIE_DOMAIN });
};

export const deleteAudiobookId = (): void => {
  Cookies.remove(AUDIOBOOK_ID_COOKIE_NAME, { domain: COOKIE_DOMAIN });
};

export const resetAuthTokenExpiration = (): void => {
  const token = authToken();
  if (token) {
    setAuthToken(token);
  }
};

export const userRole = (): BeekUserRole => {
  const role = Cookies.get(USER_ROLE_COOKIE_NAME) as BeekUserRole;
  return role;
};

export const setUserRole = (role: BeekUserRole) => {
  Cookies.set(USER_ROLE_COOKIE_NAME, role, {
    domain: COOKIE_DOMAIN,
    expires: TOKEN_COOKIE_MAX_AGE_DAYS,
  });
};

export const setChallengeId = (id: string) => {
  Cookies.set(CHALLENGE_ID_COOKIE_NAME, id, {
    domain: COOKIE_DOMAIN,
    expires: CHALLENGE_ID_COOKIE_MAX_AGE_DAYS,
  });
};

export const getChallengeId = (): string | undefined => {
  const challengeId = Cookies.get(CHALLENGE_ID_COOKIE_NAME);
  return challengeId ?? undefined;
};

export const removeChallengeId = (): void => {
  Cookies.remove(CHALLENGE_ID_COOKIE_NAME, { domain: COOKIE_DOMAIN });
};
